import React from 'react'
import { useDispatch } from 'react-redux'
import classnames from 'classnames'

import { redirectTo } from '../../../../helpers/url'

import PageSection from '../../../../features/components/PageSection'
import Button from '../../../../components/Button'

import { openForm } from '../../../../modules/actions/forms'

import { ROUTES } from '../../../../constants/routes'
import { PARTNER_ACCOUNT_CREATE, PARTNERSHIP_CREATE } from '../../../../constants/forms'

import useStyles from '../styles'

const SetUpPartnerSection = () => {
  const classes = useStyles()

  const dispatch = useDispatch()

  const createPartnerAccountButtonHandler = () => {
    redirectTo(ROUTES.partnerAccounts)
    dispatch(openForm({ formName: PARTNER_ACCOUNT_CREATE }))
  }

  const createPartnershipButtonHandler = () => {
    redirectTo(ROUTES.settingsPartnerships)
    dispatch(openForm({ formName: PARTNERSHIP_CREATE }))
  }

  return (
    <PageSection className={classes.section}>
      <h3 className={classes.sectionTitle}>Set up a new partner or sponsor</h3>
      <div className={classnames(classes.subSectionsContainer, classes.setUpPartnerSubSectionsContainer)}>
        <div className={classnames(classes.subSection, classes.numberSubSection)}>
          <span className={classes.number}>1</span>
          <div>
            <h4 className={classes.sectionSubTitle}>Create the partner account</h4>
            <p>Set up the name and logo of the partner or sponsor.</p>
            <Button onClick={createPartnerAccountButtonHandler} className={classes.actionButton}>
              Create partner account
            </Button>
          </div>
        </div>

        <div className={classnames(classes.subSection, classes.numberSubSection)}>
          <span className={classes.number}>2</span>
          <div>
            <h4 className={classes.sectionSubTitle}>Set up a new partnership</h4>
            <p>Create the first partnership for the account you created in Step 1.</p>
            <Button onClick={createPartnershipButtonHandler} className={classes.actionButton}>
              Create partnership
            </Button>
          </div>
        </div>

        <div className={classnames(classes.subSection, classes.numberSubSection)}>
          <span className={classes.number}>3</span>
          <div>
            <h4 className={classes.sectionSubTitle}>Set up margins (if applicable)</h4>
            <p>
              If margins should be applied to digital spend, set them up by selecting the partnership from the
              Partnership dropdown at the top of the page and going to the margins settings page.
            </p>
          </div>
        </div>

        <div className={classnames(classes.subSection, classes.numberSubSection)}>
          <span className={classes.number}>4</span>
          <div>
            <h4 className={classes.sectionSubTitle}>Create rights and add team</h4>
            <p>
              Create rights on the partnership dashboard and request any required files from the partner. Once ready,
              invite partner team members from the settings page.
            </p>
          </div>
        </div>
      </div>
    </PageSection>
  )
}

export default SetUpPartnerSection
